import { h, Component } from 'preact'

import 'leaflet/dist/leaflet.css'
import { Map as LeafletMap, ZoomControl, GeoJSON, ImageOverlay } from 'react-leaflet'
import { BingLayer } from 'react-leaflet-bing'

import mapImage from './berlin.png'
import Markers from '@components/Markers'
import StationsDropdown from '@components/StationsDropdown'
import berlinShape from '@data/berlin.geo.json'
import brandenburgMask from '@data/brandenburg-mask.geo.json'
import colors from '@shared/styles/colors.sass'
import _ from './styles.sass'

// constants
const BING_KEY = 'ApdIxxIIajAFxhO2Gid2cNWB-5doj4cOcRh-bEM3WOAeeKaycTWUKrR_T84yo-hF'

export default class Map extends Component {
  state = {
    showBingLayer: false
  }

  // checkSize = () => {
  //   if (!this.map) return
  //
  //   const width = this.map._container.clientWidth
  //   const height = this.map._container.clientHeight
  //
  //   if (this.prevWidth !== width || this.prevHeight !== height) {
  //     this.prevWidth = width
  //     this.prevHeight = height
  //     this.map.invalidateSize(false)
  //   }
  // }

  handleZoom = (e) => {
    const map = e.target
    map.dragging.enable()
    if (map.tap) map.tap.enable()

    this.setState({ showBingLayer: true })
  }

  // componentDidMount () {
  //   this.intervalId = setInterval(this.checkSize, 50)
  // }
  //
  // componentDidUnMount () {
  //   clearInterval(this.intervalId)
  // }

  render (props, { showBingLayer }) {
    const {
      markers,
      selectedDataset,
      isTouchEnabled
    } = props

    // TODO show message
    // "Aufgrund einer technischen Störung können momentan keine Daten angezeigt werden."
    // if (markers.length === 0) {}

    // props used for initial map rendering
    const brandenburg = {
      // you can get this info at https://nominatim.openstreetmap.org/search.php?q=Brandenburg,%20Deutschland&polygon_geojson=1&format=json
      center: { lat: 14.8461296, lng: 13.243819712887692 },
      bounds: {
        topleft: { lat: 53.5590907, lng: 11.267355 },
        bottomright: { lat: 51.159064, lng: 14.7658159 }
      },
      maxBounds: {
        topleft: { lat: 54.8590907, lng: 11.067355 },
        bottomright: { lat: 50.659064, lng: 15.2658159 }
      }
    }

    const mapProps = {
      animate: true,
      keyboard: false,
      minZoom: 6,
      maxZoom: 14,
      zoomControl: false,
      scrollWheelZoom: false,
      dragging: false,
      tap: false,
      zoomSnap: false,
      bounds: [
        [52.8, 12.8],
        [52.2, 14.1]
      ],
      maxBounds: [
        [brandenburg.maxBounds.bottomright.lat, brandenburg.maxBounds.bottomright.lng],
        [brandenburg.maxBounds.topleft.lat, brandenburg.maxBounds.topleft.lng]
      ],
      onZoom: this.handleZoom
    }

    const maskProps = {
      interactive: false,
      clickable: false,
      fillOpacity: 1,
      color: 'white',
      stroke: false
    }

    const berlinShapeProps = {
      color: colors.grey,
      fill: false,
      weight: 1
    }

    const dropdownProps = {
      stations: markers
    }

    // const dayYearSelectorProps = {
    //   id: 'dataseSelector',
    //   title: 'Ansicht Auswählen',
    //   selectedValue: selectedDataset,
    //   options: [
    //     { value: 'day', display: <span class={_.selectorContent}><b>Heute</b><br />letzte Messung</span> },
    //     { value: 'year', display: <span class={_.selectorContent}><b>letzte 12 Monate</b><br />Jahresmittelwert</span> }
    //   ],
    //   onChange: this.context.actions.selectDataset
    // }
    //

    return (<div class={props.class}>
      <LeafletMap className={_.map} {...mapProps} ref={(map) => { this.map = (map || {}).leafletElement }} >
        { showBingLayer && <BingLayer type='CanvasLight' bingkey={BING_KEY} culture='de-de' style='trs|lv:false;fc:EAEAEA_pp|lv:false;v:false_ar|v:false;lv:false_vg|v:true;fc:E1E6DA_wt|fc:AED1E4_rd|sc:d0d0d0;fc:e9e9e9_mr|sc:d3d3d3;fc:dddddd_hg|sc:d3d3d3;fc:e9e9e9_g|lc:EAEAEA' /> }
        { !showBingLayer && <ImageOverlay url={mapImage} bounds={[[53.12, 12.21], [51.89, 14.68]]} /> }
        <GeoJSON data={berlinShape} {...berlinShapeProps} />
        <GeoJSON data={brandenburgMask} {...maskProps} />
        <ZoomControl position='bottomright' />
        {/* <Rectangle bounds={mapProps.bounds} /> */}

        <Markers markers={markers} isTouchEnabled={isTouchEnabled} selectedDataset={selectedDataset} />
      </LeafletMap>

      <StationsDropdown class={_.stationsDropdown} {...dropdownProps} />

      {/* <div class={_.dayYearSelectorWrapper}>
        <TabBar class={_.dayYearSelector} {...dayYearSelectorProps} />
      </div> */}
    </div>)
  }
}
